<template>
  <VoteBase>
    <template v-slot:voteMain>
      <VoteForm :formData="data" :func="funcType" :isUpdate="isUpdate" @submitData="submitData($event)" v-if="data" />
    </template>
  </VoteBase>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'
import VoteForm from '@/components/Vote/VoteForm'
import VoteBase from './Base'

export default {
  name: 'vote-update',
  components: {VoteForm, VoteBase},
  mixins: [Error],
  data () {
    return {
      data: null,
      funcType: '修改',
      isUpdate: true
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      this.data = null
      api.detailVoteData(this, api.getVoteDetail(), 'GET', 'data', {app_id: this.$route.params.appId}, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.detailDataCallback)
    },
    submitData (data) {
      api.updateVoteData(this, api.getVoteUpdate(), 'POST', data, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.backToList)
    },
    backToList () {
      this.$router.push({name: 'vote-list', params: {oversea: !!JSON.parse(this.$route.query.oversea)}})
    },
    detailDataCallback () {
      if (!this.data.is_pull) {
        this.data.pull_config = {
          param_set: {},
          sign_params: [],
          limit_config: {
            start: null, end: null, id_page: null, per_num: null, id_par_name: null, per_num_par_name: null
          },
          fetch_method: null,
          sign_type: null,
          sign_method: null,
          sign_key: null,
          sign_par_name: null,
          url: null,
          is_hmac: null,
          fetch_ret_lambda: null
        }
      }
      this.data.is_pull = !!this.data.is_pull
      if (!this.data.bind_config) {
        this.data.bind_config = {
          is_bind_need: false,
          bind_way: 0
        }
      }
      if (!!(this.data.limit_config.is_limit & 1) && !this.data.limit_config.hasOwnProperty('user_item_limit_num')) {
        this.data.limit_config.user_item_limit_num = -1
      }
      if (!this.data.limit_config.cycle) { this.data.limit_config.cycle = 1 }
    }
  }
}
</script>



// WEBPACK FOOTER //
// VoteUpdate.vue?8a5e3ad4